import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isFetchingTransactions: true,
  isVerifyingTransaction: false,
  transactions: null,
  filteredTransactions: null,
  error: null,
};

export const transactionsSlice = createSlice({
  name: "transactions",
  initialState,
  reducers: {
    fetchTransactionsStart: (state) => {
      state.isFetchingTransactions = true;
      state.error = null;
    },
    fetchTransactionsSuccess: (state, action) => {
      state.isFetchingTransactions = false;
      state.transactions = action.payload;
    },
    fetchTransactionsFailure: (state, action) => {
      state.isFetchingTransactions = false;
      state.transactions = null;
      state.error = action.payload;
    },
    verifyTransactionStart: (state) => {
      state.isVerifyingTransaction = true;
    },
    verifyTransactionSuccess: (state) => {
      state.isVerifyingTransaction = false;
    },
    verifyTransactionFailure: (state, action) => {
      state.isVerifyingTransaction = false;
      state.error = action.payload;
    },
    setFilteredTransactions: (state, action) => {
      state.filteredTransactions = action.payload;
      state.isFetchingTransactions = false;
    },
  },
});

export const {
  fetchTransactionsFailure,
  fetchTransactionsStart,
  fetchTransactionsSuccess,
  verifyTransactionFailure,
  verifyTransactionStart,
  verifyTransactionSuccess,
  setFilteredTransactions,
} = transactionsSlice.actions;

const transactionsReducer = transactionsSlice.reducer;

export default transactionsReducer;
